<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Calificar contratista</span
            >
            <!-- <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>-->
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-dialog-content class="p-16 pb-0 m-0">
        <p>
            Califique al contratista
            <strong
                >{{ oott.trabajo.contratista.nombres }}
                {{ oott.trabajo.contratista.apellidos }}</strong
            >
            por el trabajo
            <strong
                >{{ oott.servicio.descripcion }}
                {{ oott.servicio.atributos.join(" ") }}</strong
            >
            realizado
        </p>

        <app-star-rating
            [seteable]="true"
            (evaluacionEvent)="setEvaluacion($event)"
        ></app-star-rating>
    </mat-dialog-content>

    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <!--  <button mat-button mat-dialog-close>En otro momento</button>-->

        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="evaluacion"
            [disabled]="evaluacion === -1"
        >
            Calificar
        </button>
    </mat-dialog-actions>
</div>
